import { StaticImageData } from 'next/image';

import ugreenStorageReader from '@/assets/img/tiktok-shop/616goUqHzQL._AC_SX679_.jpg'
import airpodsFoamTips from '@/assets/img/tiktok-shop/71iZOkOAKVL._AC_SX679_.jpg'
import iphoneCase from '@/assets/img/tiktok-shop/Sbdf4b0247b71439aae26983dd6f1a01dR.jpg_960x960q75.jpg_.avif'
import lite84 from '@/assets/img/tiktok-shop/61z5Q8bkrkL._AC_SX679_.jpg'
import aurzenProjector from '@/assets/img/tiktok-shop/61M8vRKzOfL._AC_SL1500_.jpg'
import torrasIphoneCase from '@/assets/img/tiktok-shop/71izgSRAsmL._AC_SL1500_.jpg'
import omniCase from '@/assets/img/tiktok-shop/Omni-Front_1.jpg'
import ankerMagGoPowerBank from '@/assets/img/tiktok-shop/61U4FubHHoL._AC_SL1500_.jpg'
import gshockDW5600BB from '@/assets/img/tiktok-shop/81vU7IvqSJL._AC_SY879_.jpg'
import kantoSpeakerStands from '@/assets/img/tiktok-shop/71lf-U-XAgL._AC_SL1500_.jpg'
import elevationLabsTimeCapsule from '@/assets/img/tiktok-shop/7140ksFyEmL._AC_SL1500_.jpg'
import ankerLaptopCharger140W from '@/assets/img/tiktok-shop/71xzFkRJGvL._AC_SL1500_.jpg'
import samsungTypeCFlashDrive from '@/assets/img/tiktok-shop/817xK9Cd6JL._AC_SL1500_.jpg'
import patagoniaTerravia from '@/assets/img/tiktok-shop/patagonia-pack.jpg'
import ankerNanoPowerBank from '@/assets/img/tiktok-shop/anker-10k-powerbank.jpg'
import ankerNanoCharger45W from '@/assets/img/tiktok-shop/anker-45w-smart-display-charger.jpg'
import moftTripodWallet from '@/assets/img/tiktok-shop/moft-tripod-stand-wallet.jpg'
import orbitKeyOrganizerPro from '@/assets/img/tiktok-shop/orbit-key-key-organizer-pro.webp'
import orbitKeySlimCase from '@/assets/img/tiktok-shop/orbitkey-airtag-holder.webp'
import mahoganyTeakwood from '@/assets/img/tiktok-shop/mahogony-teakwood.jpg'
import kershawIridium from '@/assets/img/tiktok-shop/kershaw-iridium.webp'
import satechim2enclosure from '@/assets/img/tiktok-shop/61RVAJWo+eL._AC_SX679_.jpg'
import humanCentricVerticalStand from '@/assets/img/tiktok-shop/51R5I6OF8DL._AC_SL1500_.jpg'
import ankerMagSafe360Stand from '@/assets/img/tiktok-shop/61xeJd5rczL._AC_SX679_.jpg'

export type Product = {
  title: string;
  href: string;
  img: StaticImageData | null;
};

export const products: Product[] = [
  {
    title: 'Anker MagSafe 360 Charging Stand',
    href: 'https://link.amazon/B0dllepMO',
    img: ankerMagSafe360Stand
  },
  {
    title: 'HumanCentric Vertical Laptop Stand',
    href: 'https://link.amazon/B0c7vdIhM',
    img: humanCentricVerticalStand
  },
  {
    title: 'Satechi M.2 NVMe Mini SSD Enclosure',
    href: 'https://amzn.to/4bzMhul',
    img: satechim2enclosure
  },
  {
    title: 'Patagonia Terravia Mini Hip Pack',
    href: 'https://amzn.to/4vImQOl',
    img: patagoniaTerravia
  },
  {
    title: 'Anker Nano Power Bank',
    href: 'https://amzn.to/498kU9z',
    img: ankerNanoPowerBank
  },
  {
    title: 'Anker Nano Charger 45W',
    href: 'https://amzn.to/4nyqKqA',
    img: ankerNanoCharger45W
  },
  {
    title: 'MOFT Phone Tripod Wallet',
    href: 'https://amzn.to/3RqiKvV',
    img: moftTripodWallet
  },
  {
    title: 'OrbitKey Key Organizer Pro',
    href: 'https://plaen.co/s/6HmmuuFZ',
    img: orbitKeyOrganizerPro
  },
  {
    title: 'OrbitKey Slim Case',
    href: 'https://plaen.co/s/yhpOuvqg',
    img: orbitKeySlimCase
  },
  {
    title: 'Bath & Body Works Mahongany Teakwood',
    href: 'https://plaen.co/s/DsG7Xq4s',
    img: mahoganyTeakwood
  },
  {
    title: 'Kershaw Iridium',
    href: 'https://plaen.co/s/nFhmmHBj',
    img: kershawIridium
  },
  {
    title: 'UGREEN USB-C SD Card Reader',
    href: 'https://amzn.to/42lT5H8',
    img: ugreenStorageReader
  },
  {
    title: 'Comply TrueGrip MAX',
    href: 'https://amzn.to/4tsPdQq',
    img: airpodsFoamTips
  },
  {
    title: 'Corrugated iPhone Case',
    href: 'https://plaen.co/s/QDy3tcve',
    img: iphoneCase
  },
  {
    title: 'Flow Lite 84 Keyboard',
    href: 'https://amzn.to/4bNGIsZ',
    img: lite84
  },
  {
    title: 'Aurzen Zip Projector',
    href: 'https://amzn.to/4c0vsYO',
    img: aurzenProjector
  },
  {
    title: 'Torras Slim iPhone Case',
    href: 'https://amzn.to/4c60Qp5',
    img: torrasIphoneCase
  },
  {
    title: 'Piorama Omni Latop Sleeve',
    href: 'https://plaen.co/s/ZbWNpAqc',
    img: omniCase
  },
  {
    title: 'Anker MagGo Powerbank',
    href: 'https://amzn.to/4tswLqW',
    img: ankerMagGoPowerBank
  },
  {
    title: 'G-Shock Unisex DW-5600BB',
    href: 'https://amzn.to/4v5coSb',
    img: gshockDW5600BB
  },
  {
    title: 'Kanto S2 Speaker Stands',
    href: 'https://amzn.to/4sN2Qth',
    img: kantoSpeakerStands
  },
  {
    title: 'Elevation Labs TimeCapsule',
    href: 'https://amzn.to/4mbgsMM',
    img: elevationLabsTimeCapsule
  },
  {
    title: 'Anker Laptop Charger 140W',
    href: 'https://amzn.to/3NI2RzH',
    img: ankerLaptopCharger140W
  },
  {
    title: 'Samsung Type-C USB Flash Drive',
    href: 'https://amzn.to/4m50y6v',
    img: samsungTypeCFlashDrive
  },
];
